
import { forkJoin,  Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { NgModule } from '@angular/core';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { EmailDistributionFilterModel, NewsroomFilterModel } from './model/amplify-request.model';
import { ServiceApi } from '../genericApi/service-api';
import { StoryModel } from '../../api/amplify/model/amplify-reponse.model';
import { AmplifyTypesEnum } from './enums/amplify-types.enum';
import { environment } from '../../../environments/environment';
import { StorySearchParams } from '../../api/story/model/story-search-Query-Params.model';
import { AmplifyStoryResultModel } from '../../api/amplify/model/amplify-unified.model';
import { ConfigService } from '../../Core/Config/services/config.service';
import { ArticleViewModel } from '../../api/amplify/model/amplify-article-model';

@NgModule({
    providers: []
})


export class AmplifyApi {
    private unifiedDistributionRequestModel: EmailDistributionFilterModel;
    private unifiedNewsroomRequestModel: NewsroomFilterModel;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {}

    public getNewroomStoryList(reqModel: NewsroomFilterModel, reqParams: StorySearchParams ): Observable<AmplifyStoryResultModel> {

        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<AmplifyStoryResultModel>(
            '/stories/search',
            reqModel,
            HttpVerbsEnum.POST,
            reqParams
        );
    }

    /* Convert Distribution/Story to amplify Story Model
    *
    * @param {StoryModel} storyModel
    * @param {AmplifyTypesEnum} type
    * @returns {StoryModel}
    */
    private mapDistributionsStoriesToModel(storyModel: StoryModel, type: AmplifyTypesEnum): StoryModel {
        const amplifyStoryModel: StoryModel = new StoryModel();
        amplifyStoryModel.type = type;
        amplifyStoryModel.id = storyModel.id;
        amplifyStoryModel.name = storyModel.name;
        amplifyStoryModel.modifiedDate = new Date(storyModel.modifiedDate);

        return amplifyStoryModel;
    }

    /* Get article details from Newswire
    * @param {number} articleId
    * @returns {Observable<ArticleViewModel>}
    */
    public getNewswireArticleDetail(
        articleId: number
    ): Observable<ArticleViewModel> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;
        return this.serviceApi.api<ArticleViewModel>(
            '/articles',
            null,
            HttpVerbsEnum.GET,
            {'articleId' : articleId},
        );
    }
}
